import { CookiesMessage } from "./scripts/components/cookies-message";

export class Bootstraper {
    public static bootsrtapOnWindowLoaded(page): void {
        window.addEventListener('load', function() {
            new page();
            new CookiesMessage();
        });
    }
}
